import { Box, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';

import {
  CustomButton,
  CustomTextField,
  DrawerFormSection,
} from '../../../../common/components';
import { CURRENCY_OPTIONS } from '../../constants/supplierLedgerConstants';
import { formatCurrencyAmount } from '../../utils/supplierLedgerFormatters';
import {
  AmountLineRow,
  AmountPanel,
  FieldSelect,
  summaryControlSx,
  summaryInputSx,
} from '../SupplierLedgerShared';

const SupplierInvoiceAmountsSection = ({
  accountingAccountOptions = [],
  accountingAccountsLoading = false,
  amountLines,
  amountTotals,
  form,
  locksFinancialFields,
  movementConceptOptions = [],
  movementConceptsLoading = false,
  onAddAmountLine,
  onAmountLineChange,
  onChange,
  onRemoveAmountLine,
}) => (
  <DrawerFormSection
    title="Importes"
    action={(
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', justifyContent: 'flex-end' }}>
        <FieldSelect
          label="Moneda"
          name="currency"
          value={form.currency}
          onChange={onChange}
          options={CURRENCY_OPTIONS}
          sx={{
            width: 110,
            mt: 0,
            pointerEvents: locksFinancialFields ? 'none' : 'auto',
            opacity: locksFinancialFields ? 0.65 : 1,
            '& .MuiOutlinedInput-root': {
              height: 40,
              minHeight: 40,
              fontSize: '0.9rem',
            },
            '& .MuiInputBase-input': {
              fontSize: '0.9rem',
            },
          }}
        />
        <CustomButton
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={onAddAmountLine}
          disabled={locksFinancialFields}
          sx={{ height: 40, width: 172, px: 2, fontSize: '0.9rem', whiteSpace: 'nowrap' }}
        >
          Agregar importe
        </CustomButton>
      </Box>
    )}
    grid={false}
  >
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25, minWidth: 0 }}>
      <Box sx={{ minWidth: 0, display: 'flex', flexDirection: 'column', gap: 1.25 }}>
        {form.currency === 'USD' && (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '170px minmax(0, 1fr)' },
              gap: 1.25,
              alignItems: 'start',
            }}
          >
            <CustomTextField
              label="Cotización ARS"
              name="exchange_rate_to_ars"
              value={form.exchange_rate_to_ars}
              onChange={onChange}
              disabled={locksFinancialFields}
            />
          </Box>
        )}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
          {amountLines.map((line, index) => (
            <AmountLineRow
              key={line.id}
              line={line}
              accountingAccountOptions={accountingAccountOptions}
              accountingAccountsLoading={accountingAccountsLoading}
              movementConceptOptions={movementConceptOptions}
              movementConceptsLoading={movementConceptsLoading}
              index={index}
              currency={form.currency}
              canRemove={amountLines.length > 1}
              amountsLocked={locksFinancialFields}
              onChange={onAmountLineChange}
              onRemove={onRemoveAmountLine}
            />
          ))}
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
          minWidth: 0,
          p: 1.25,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 1,
          backgroundColor: 'background.paper',
        }}
      >
        <Typography variant="subtitle2" sx={{ color: 'primary.main', fontWeight: 800 }}>
          Resumen
        </Typography>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              lg: 'repeat(3, minmax(0, 1fr))',
            },
            gap: 1.25,
            minWidth: 0,
          }}
        >
          <AmountPanel
            label="Subtotal importes"
            value={formatCurrencyAmount(amountTotals.gross, form.currency)}
            sx={summaryControlSx}
          />
          <CustomTextField
            label="Perc. IVA"
            name="vat_perception_amount"
            value={form.vat_perception_amount}
            onChange={onChange}
            disabled={locksFinancialFields}
            sx={summaryInputSx}
          />
          <CustomTextField
            label="Perc. IIBB"
            name="gross_income_perception_amount"
            value={form.gross_income_perception_amount}
            onChange={onChange}
            disabled={locksFinancialFields}
            sx={summaryInputSx}
          />
          <AmountPanel
            label="Total factura"
            value={formatCurrencyAmount(amountTotals.total, form.currency)}
            sx={summaryControlSx}
          />
          <AmountPanel
            label="Neto acumulado"
            value={formatCurrencyAmount(amountTotals.net, form.currency)}
            sx={summaryControlSx}
          />
          <AmountPanel
            label="IVA acumulado"
            value={formatCurrencyAmount(amountTotals.vat, form.currency)}
            sx={summaryControlSx}
          />
        </Box>
      </Box>
    </Box>
  </DrawerFormSection>
);

export default SupplierInvoiceAmountsSection;
